import * as angular from "angular";
import template from "./activity-trigger-actions.html";
import type {
	ActivityTriggerAction,
	ActivityTriggerFieldId
} from "../../services/activity-trigger";

interface ReportFormActivityTriggerController {
	getActivityTriggerFieldActions(fieldId: ActivityTriggerFieldId): ActivityTriggerAction[];
	getActivityTriggerSectionActions(sectionId: ActivityTriggerFieldId): ActivityTriggerAction[];
	isActivityTriggerActionAvailable(action: ActivityTriggerAction): boolean;
	runActivityTriggerAction(action: ActivityTriggerAction): Promise<boolean>;
}

// AngularJS owns these binding properties; keeping them type-only preserves pre-assigned values.
export interface Controller {
	fieldId?: ActivityTriggerFieldId;
	sectionId?: ActivityTriggerFieldId;
	showLabel?: boolean;
	reportFormCtrl: ReportFormActivityTriggerController;
}

// eslint-disable-next-line no-redeclare
export class Controller {
	actions: ActivityTriggerAction[] = [];

	$onInit(): void {
		if(this.fieldId !== undefined) {
			this.actions = this.reportFormCtrl.getActivityTriggerFieldActions(this.fieldId);
		}
		else if(this.sectionId !== undefined) {
			this.actions = this.reportFormCtrl.getActivityTriggerSectionActions(this.sectionId);
		}
	}

	isAvailable(action: ActivityTriggerAction): boolean {
		return this.reportFormCtrl.isActivityTriggerActionAvailable(action);
	}

	getActionLabel(action: ActivityTriggerAction): string {
		return this.showLabel === true && action.code === "point"
			? "Record"
			: action.label;
	}

	execute(action: ActivityTriggerAction): Promise<boolean> {
		return this.reportFormCtrl.runActivityTriggerAction(action);
	}
}

export default angular
	.module("vesl.components.report-form.activity-trigger-actions", [])
	.component("activityTriggerActions", {
		template,
		controller: Controller,
		bindings: {
			fieldId: "<",
			sectionId: "<",
			showLabel: "<"
		},
		require: {
			reportFormCtrl: "^^reportForm"
		}
	}).name;
